import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, collection, getDocs } from 'firebase/firestore';
import { db, storage } from '../../Firebase/Firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import LoadingScreen from '../../Components/loading';
import Navbar from '../../Components/NavBarV2';
import Footer from '../../Components/footer';
import { FiUpload } from 'react-icons/fi';
import './ActualizarInformacionMarca.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const EditarMarca = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [marca, setMarca] = useState(null);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [lugares, setLugares] = useState([]);
    const [loadingLugares, setLoadingLugares] = useState(true);
    useEffect(() => {
        const fetchMarca = async () => {
            try {
                const marcaRef = doc(db, 'marca', id);
                const snap = await getDoc(marcaRef);
                if (snap.exists()) {
                    const data = snap.data();

                    // Inicializar redes con valores por defecto si están vacías
                    if (!data.redes || data.redes.length === 0) {
                        data.redes = [
                            'Facebook: ',
                            'Instagram: ',
                            'LinkedIn: ',
                            'TwitterX: ',
                            'YouTube: ',
                        ];
                    }

                    setMarca(data);
                } else {
                    console.error('Marca no encontrada');
                }
                setLoading(false);
            } catch (err) {
                console.error('Error al cargar marca:', err);
                setLoading(false);
            }
        };
        fetchMarca();
    }, [id]);


    const handleFileChange = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return;
        const file = e.target.files[0];

        setUploading(true);

        try {
            // Borrar imagen anterior si existe
            if (marca.logo) {
                try {
                    const oldRefPath = marca.logo.split('/o/')[1].split('?')[0];
                    const oldRef = ref(storage, decodeURIComponent(oldRefPath));
                    await deleteObject(oldRef);
                    console.log('Imagen anterior eliminada');
                } catch (error) {
                    console.warn('No se pudo eliminar imagen anterior:', error);
                }
            }

            // Subir nueva imagen
            const storageRef = ref(storage, `logos/${id}_${file.name}`);
            await uploadBytes(storageRef, file);
            const newUrl = await getDownloadURL(storageRef);

            setMarca((prev) => ({ ...prev, logo: newUrl }));
            setUploading(false);
        } catch (error) {
            console.error('Error subiendo la imagen:', error);
            setUploading(false);
        }
    };
    useEffect(() => {
        const fetchLugares = async () => {
            setLoadingLugares(true);
            try {
                const lugaresColRef = collection(db, 'marca', id, 'lugar');
                const querySnapshot = await getDocs(lugaresColRef);
                const lugaresList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setLugares(lugaresList);
            } catch (error) {
                console.error('Error al cargar lugares:', error);
                setLugares([]);
            }
            setLoadingLugares(false);
        };

        fetchLugares();
    }, [id]);
    const actualizarMarca = async () => {
        try {
            const marcaRef = doc(db, 'marca', id);
            await updateDoc(marcaRef, {
                ...marca,
                fechaActualizacion: new Date(),
            });
            alert('✅ Marca actualizada correctamente');
            navigate('/admin/marcas');
        } catch (err) {
            console.error('Error al actualizar:', err);
            alert('❌ Error al actualizar');
        }
    };

    if (loading || !marca) return <LoadingScreen />;

    return (
        <>
            <Navbar />
            <div className="editar-marca-container">
                <h2>Editar Marca</h2>

                {/* Logo */}
                <div className="logo-upload-container">
                    {marca.logo && (
                        <img
                            src={marca.logo}
                            alt="Logo de la marca"
                            className="logo-preview"
                        />
                    )}
                    <label htmlFor="logo-upload" className="logo-upload-label" title="Cambiar logo">
                        <FiUpload size={28} />
                    </label>
                    <input
                        id="logo-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        disabled={uploading}
                    />
                </div>

                <label>Nombre:</label>
                <input
                    type="text"
                    value={marca.nombre}
                    onChange={(e) => setMarca({ ...marca, nombre: e.target.value })}
                />

                <label>Correo:</label>
                <input
                    type="email"
                    value={marca.correo}
                    onChange={(e) => setMarca({ ...marca, correo: e.target.value })}
                />

                <label>Teléfono:</label>
                <input
                    type="text"
                    value={marca.telefono}
                    onChange={(e) => setMarca({ ...marca, telefono: e.target.value })}
                />

                <label>Descripción:</label>
                <textarea
                    value={marca.descripcion}
                    onChange={(e) => setMarca({ ...marca, descripcion: e.target.value })}
                ></textarea>

                <h3>Redes Sociales</h3>
                <div className="redes-sociales-container">
                    {[
                        { nombre: 'Facebook', icono: <FaFacebookF /> },
                        { nombre: 'Instagram', icono: <FaInstagram /> },
                        { nombre: 'LinkedIn', icono: <FaLinkedinIn /> },
                        { nombre: 'TwitterX', icono: <FaTwitter /> },
                        { nombre: 'YouTube', icono: <FaYoutube /> },
                    ].map(({ nombre, icono }, idx) => {
                        const valor = marca.redes && marca.redes[idx] ? marca.redes[idx].split(': ')[1] : '';
                        return (
                            <div key={nombre} className="red-social-field">
                                <div className="red-social-icon">{icono}</div>
                                <input
                                    type="url"
                                    placeholder={`URL de ${nombre}`}
                                    value={valor}
                                    onChange={(e) => {
                                        const nuevoUrl = e.target.value;
                                        let redesCopy = marca.redes ? [...marca.redes] : [];
                                        redesCopy[idx] = `${nombre}: ${nuevoUrl}`;
                                        setMarca({ ...marca, redes: redesCopy });
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>

                <label>¿Activo?</label>
                <select
                    value={marca.Activo}
                    onChange={(e) => setMarca({ ...marca, Activo: e.target.value === 'true' })}
                >
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                </select>

                <button onClick={actualizarMarca} disabled={uploading}>
                    {uploading ? 'Subiendo logo...' : 'Guardar cambios'}
                </button>
            </div>
            <div className="adminlugares-list">
                {lugares.map(lugar => (
                    <Link
                        to={`/proveedor/marca/${id}/lugar/${lugar.IdLugar}`}
                        key={lugar.id}
                        className="adminlugares-item-link"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <div className="adminlugares-item">
                            <img src={lugar.ImagenUrl} alt={lugar.NombreLugar} className="adminlugares-img" />
                            <div className="adminlugares-info">
                                <h4 className="adminlugares-title">{lugar.NombreLugar}</h4>
                                <p><strong>Ciudad:</strong> {lugar.CiudadLugar}</p>
                                <p><strong>Sector:</strong> {lugar.Sector}</p>
                                <p><strong>Dirección:</strong> {lugar.Direccion}</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>


            <Footer />
        </>
    );
};

export default EditarMarca;
